import api from "./client";
export async function getOverview(params) {
    const res = await api.get("/admin/analytics/overview", { params });
    return res.data;
}
export async function getTimeseries(params) {
    const res = await api.get("/admin/analytics/timeseries", { params });
    return res.data;
}
export async function getTopPages(params) {
    const res = await api.get("/admin/analytics/top-pages", { params });
    return res.data;
}
export async function getTopListings(params) {
    const res = await api.get("/admin/analytics/top-listings", { params });
    return res.data;
}
export async function getDeviceBreakdown(params) {
    const res = await api.get("/admin/analytics/devices", { params });
    return res.data;
}
export async function getReferers(params) {
    const res = await api.get("/admin/analytics/referers", { params });
    return res.data;
}
